import { debug } from "@/api/logging"
import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
Vue.use(VueCompositionAPI)
import { ref, reactive, readonly } from '@vue/composition-api'

const message = ref()
const commit_message = function(msg) {
  message.value = msg
}

export {
  message, commit_message,
}
